import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpHeaders, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { TranslocoService } from '@ngneat/transloco';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { environment } from 'environments/environment';


/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const _toast = inject(ToastrService);
    const _translate = inject(TranslocoService);

    // Clone the request object
    let newReq = req.clone();


    if (authService.session && !AuthUtils.isTokenExpired(authService.session.Token)) {
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + authService.session.Token,
            'Content-Type': 'application/json'
        });
        newReq = req.clone({ headers });
    } else {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        newReq = req.clone({ headers });
    }
    
    const uploadFile = req.url.toLowerCase().includes('upload');
    if (authService.session && !AuthUtils.isTokenExpired(authService.session.Token)) {
        const contentType = !uploadFile ? {'content-type': 'application/json'} : {};
        newReq = req.clone({ setHeaders: { 'Authorization': 'Bearer ' +authService.session.Token, ...contentType, } });
    } else {
        if (!uploadFile) {newReq = req.clone({ setHeaders: { 'content-type': 'application/json' } });}
        else { newReq = req.clone(); }
    }

    // Response
    return next(newReq)
        .pipe(
            catchError((error) => {

                

                // Catch "401 Unauthorized" responses
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    // Sign out
                    // authService.signOut();

                    // Reload the app
                    //location.reload();
                } else if (error instanceof HttpErrorResponse && error.status === 500) {


                    let message = { title: 'Title.Error', errorServer: 'Message.ErrorServer' };
                    _translate
                        .selectTranslate(Object.values(message))
                        .subscribe((data) => {

                            message.title = data[0];
                            message.errorServer = data[1];
                            _toast.error(message.errorServer, message.title);
                        });

                } else if (error instanceof HttpErrorResponse && error.status === 0) {
                  
                    // authService.signOut();
                    // location.reload();
                }



                return throwError(error);
            }),
        );
};
